"use client";

import CookiePolicyContentTh from "./CookiePolicyContent.th";
import CookiePolicyContentEn from "./CookiePolicyContent.en";

export default function CookiePolicyContent({ lang = "th" }: { lang?: "th" | "en" }) {
  if (lang === "en") return <CookiePolicyContentEn />;
  return <CookiePolicyContentTh />;
}
